import { Target } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Mission, Todo } from '@/types/todo';

interface CompletedMissionItemProps {
  mission: Mission;
  allTodos: Todo[];
}

export default function CompletedMissionItem({ mission, allTodos }: CompletedMissionItemProps) {
  // Calculate mission todos and bonus points
  const missionTodos = allTodos.filter(todo => todo.missionId === mission.id);
  const completedTodos = missionTodos.filter(todo => todo.completed);
  const bonusPoints = completedTodos.length * 10; // 10 bonus points per completed todo
  
  // Format mission size for display
  const getSizeColor = (size: string) => {
    switch (size) {
      case 'S': return 'bg-green-500';
      case 'M': return 'bg-blue-500';
      case 'L': return 'bg-orange-500';
      case 'XL': return 'bg-red-500';
      case 'XXL': return 'bg-purple-500';
      default: return 'bg-gray-500';
    }
  };
  
  return (
    <Card className="pt-4 pb-4 pl-6 pr-6 bg-muted/50">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-6 h-6 rounded-full bg-success flex items-center justify-center">
            <Target size={14} className="text-white" />
          </div>
          <div>
            <div className="flex items-center gap-2 mb-1">
              <h3 className="font-medium text-foreground line-through opacity-75">
                {mission.name}
              </h3>
              <Badge 
                variant="outline" 
                className={`${getSizeColor(mission.size)} text-white border-none text-xs px-1.5 py-0`}
              >
                {mission.size}
              </Badge>
            </div>
            <p className="text-sm text-muted-foreground">
              Mission completed • {completedTodos.length} tasks
            </p>
          </div>
        </div>
        
        <Badge 
          variant="default"
          className="bg-success text-white"
        >
          +{bonusPoints} pts
        </Badge>
      </div>
    </Card>
  );
}